import { useRemoveEntryTemplate } from "@tandemdiabetes/sugarmate-api-react-client"
import type { EntryTemplate } from "@tandemdiabetes/sugarmate-api-react-client"
import { useDeleteCollectionItem } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useDeleteEntryTemplate() {
  return useDeleteCollectionItem<"entry_template", EntryTemplate>(
    CollectionKey.EntryTemplate,
    "entry_template",
    useRemoveEntryTemplate,
    (i) => i,
  )
}
